import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PasswordValidation } from './password-validation';

@Component({
  selector: 'asv-reset-password',
  template: `
    <div class="content-box form-width section-top login">
      <form class="mx-auto" [formGroup]="signinForm">
        <h2 class="text-center">{{ 'sign.reset_password.title' | translate }}</h2>
        <h3 class="text-center">{{ 'sign.reset_password.description' | translate }}</h3>
        <div class="form-group mt-5">
          <label for="field_password">{{ 'forms.fields.password' | translate }}</label>
          <div class="password-icon">
            <input type="password"
                 class="form-control"
                 id="field_password"
                 formControlName="password"
                 placeholder="{{ 'forms.fields.password' | translate }}">
          </div>
        </div>
        <div class="form-group mt-5">
          <label for="confirm_password">{{ 'forms.fields.confirm_password' | translate }}</label>
          <div class="password-icon">
            <input type="password"
                 class="form-control"
                 id="confirm_password"
                 formControlName="confirm_password"
                 placeholder="{{ 'forms.fields.confirm_password' | translate }}">
          </div>
        </div>
        <div class="form-group mt-5">
          <button type="button" class="btn btn-success btn-block" (click)="signin()">{{ 'buttons.save_password' | translate }}</button>
          <button type="button" class="btn btn-secondary btn-block" (click)="cancel()">{{ 'buttons.cancel' | translate }}</button>
        </div>
      </form>
    </div>
  `,
  styles: [`
    :host {
      width: 100%;
    }
  `]
})
export class ResetPasswordComponent implements OnInit {
  public signinForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router
  ) { }

  ngOnInit() {
    this.makeForm();
  }

  public makeForm() {
    this.signinForm = this.formBuilder.group({
      password: ['', Validators.required],
      confirm_password: ['', Validators.required]
    }, {
      validator: PasswordValidation.MatchPassword
    });
  }

  public signin() {
    this.router.navigateByUrl('/sign/signin');
  }

  public cancel() {
    this.router.navigateByUrl('/sign/signin');
  }

}
